var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dialog-actions"},[_c('div',{staticClass:"dialog-actions__left"},[_vm._t("left")],2),_vm._t("default"),_c('div',{staticClass:"dialog-actions__right"},[_vm._t("right")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }